import axios from "axios";

const API_BASE = "https://fliplyn-b-c.fly.dev";

export const getOwners = async (skip = 0, limit = 10) => {
  const res = await axios.get(`${API_BASE}/owners/?skip=${skip}&limit=${limit}`);
  return res.data;
};

export const getActiveOwners = async (skip = 0, limit = 10) => {
  const res = await axios.get(`${API_BASE}/owners/active?skip=${skip}&limit=${limit}`);
  return res.data;
};

export const getInactiveOwners = async (skip = 0, limit = 10) => {
  const res = await axios.get(`${API_BASE}/owners/inactive?skip=${skip}&limit=${limit}`);
  return res.data;
};
